import { AppTitle } from '@/components/app-header/app-header';
import { CompanyInformationForm } from './company-information-form';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbSeparator,
  BreadcrumbPage
} from '@/components/ui/breadcrumb';
import { TeamInformationForm } from './team-information-form';
import { EditableAvatar } from '@/components/editable-avatar';
import { useState } from 'react';
import { useOrganization } from '@clerk/clerk-react';
import { toast } from '@/hooks/use-toast';

export function MerchantSettings() {
  const { organization, membership } = useOrganization();
  const [photoLoading, setPhotoLoading] = useState(false);
  const [removePhotoLoading, setRemovePhotoLoading] = useState(false);
  const isAdmin = membership?.role === 'org:admin';

  const handleAvatarChange = async (image: string) => {
    try {
      setPhotoLoading(true);
      const imageBlob = await fetch(image).then((r) => r.blob());
      await organization?.setLogo({ file: imageBlob });
    } catch (_error) {
      toast({
        title: 'Error',
        description: 'Failed to update profile image',
        variant: 'destructive'
      });
    } finally {
      setPhotoLoading(false);
    }
  };

  const handleAvatarRemove = async () => {
    try {
      setRemovePhotoLoading(true);
      await organization?.setLogo({ file: null });
    } catch (_error) {
      toast({
        title: 'Error',
        description: 'Failed to remove profile image',
        variant: 'destructive'
      });
    } finally {
      setRemovePhotoLoading(false);
    }
  };

  return (
    <>
      <AppTitle>
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem className="text-base">Settings</BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage className="text-base">Merchant</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      </AppTitle>
      <div className="max-w-[800px] mx-auto space-y-6">
        <div className="flex justify-between items-center bg-card/50 border rounded-lg p-3.5">
          <div className="flex items-center gap-3">
            <EditableAvatar
              image={organization?.imageUrl}
              hasUploadedImage={Boolean(organization?.hasImage)}
              name={organization?.name ?? ''}
              size="md"
              display="square"
              onImageChange={handleAvatarChange}
              onImageRemove={handleAvatarRemove}
              isLoading={photoLoading || removePhotoLoading}
              disabled={!isAdmin}
            />
            <div>
              <h1 className="text-xl font-semibold">{organization?.name}</h1>
            </div>
          </div>
        </div>
        <Tabs defaultValue="company-info">
          <TabsList className="rounded-xl">
            <TabsTrigger className="rounded-lg" value="company-info">
              Company Information
            </TabsTrigger>
            <TabsTrigger className="rounded-lg" value="teams">
              Team
            </TabsTrigger>
          </TabsList>
          <TabsContent value="company-info">
            <CompanyInformationForm />
          </TabsContent>
          <TabsContent value="teams">
            <TeamInformationForm />
          </TabsContent>
          {/* <TabsContent value="billing">
          <Card>
            <CardHeader>
              <CardTitle>Payment Method</CardTitle>
              <CardDescription>Your Card information for billing</CardDescription>
            </CardHeader>
            <CardContent>
              <Elements
                stripe={stripePromise}
                options={{
                  mode: 'setup',
                  currency: 'usd',
                }}
              >
                <PaymentElement />
              </Elements>
            </CardContent>
          </Card>
        </TabsContent> */}
        </Tabs>
      </div>
    </>
  );
}
